FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};

    //  element
    var ELEM = 'table[data-fd="tblfrozencolumns"]',
        ALTERNATIVE_ELEM = '[data-fd2="tblfrozencolumns"]';

    function getElement(){
        return $(ELEM).length > 0 ? ELEM : ALTERNATIVE_ELEM;
    }

    $.widget("custom.tabelFrozenColumns", {
        options: {
            element: '',
            frozencolumns: 1
        },
        _create: function () {
            $.extend(this.options, this.element.data());
            this.element.addClass("table-in-page");
            this._fixHeadersAndColumns(this.options.frozencolumns);
            this.refresh();

            const resizeObserver = new ResizeObserver(entries => {
                this.refresh();
                $(getElement()).hide().show(0);
            });
            resizeObserver.observe(document.querySelector(getElement()));
        },
        _fixHeadersAndColumns: function (cols) {
            cols = cols ?? 1;
            const $table = $(getElement());
            const $hTrs = $table.find("thead>tr");
            let cTop = $(".site-fixed-top-content").height() + $(".site-top-navigation").height();
            $hTrs.each(function (_) {
                $(this).find("th").each(function () {
                    const index = $(this).index();
                    const isStickyCol = index < (cols);
                    const thTop = cTop;
                    const zindex = isStickyCol ? 11 : 10;
                    $(this).css("position", "sticky").css("top", thTop).css("z-index", zindex);
                });
            });
            let colLeft = [];
            const $cols = $table.find("tbody>tr").find("th:lt(" + cols + "), td:lt(" + cols + ")");
            let cLeft = 16;
            if ($cols.hasClass("text-muted") && $cols.attr('colspan')) {
                return;
            }
            $cols.each(function () {                
                const index = $(this).index();
                colLeft[index] = colLeft[index] ? colLeft[index] : cLeft;
                const zindex = 10;
                $(this).css("position", "sticky").css("left", colLeft[index]).css("z-index", zindex);
                cLeft += $(this).outerWidth();
            });

            const $thCols = $table.find("thead>tr").find("th:lt(" + cols + ")");
            cLeft = 16; // Padding
            $thCols.each(function () {
                const index = $(this).index();
                colLeft[index] = colLeft[index] ? colLeft[index] : cLeft;
                $(this).css("left", colLeft[index]);
                cLeft += $(this).outerWidth();
            });
            // Only observe the second box                
        },
        _setOptions: function (options) {
            this._super(options);
            this.element.data(options);
            this.refresh();
        },
        refresh: function () {
            this._fixHeadersAndColumns(this.options.frozencolumns);
        },
        attach: function (self) {
            this.element = self;
        },
        _destroy: function () {
        }
    });


    /* ========================================================================
     *  public methods
     * ========================================================================
    */


    //  global setter
    child.setTableFrozenCol = function (container, defaults) {
        var list = '';
        if (container) {
            if (typeof container === 'string') {
                container = $(container);
            }
            list = container.is(getElement()) ? container : container.find(getElement());
        } else {
            list = $(getElement());
        }

        return $(list).tabelFrozenColumns(defaults);
    };


    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));